<template>
    <div>
        <h3 class="stack-m">Analysis</h3>
        <div :class="{'stack-m': hasRejection}">
            <span>This document was {{document.status}} on {{document.updatedTime | dateTime}}</span>
        </div>
        <table v-if="hasRejection" class="table table-definition table-collapsed">
            <tbody>
                <tr>
                    <td>Rejection Reason</td>
                    <td>{{rejection.type | unKebabCase}}</td>
                </tr>
                <tr>
                    <td>Rejection Message</td>
                    <td>{{rejection.message}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'review-details',
        props: {
            document: {
                type: Object,
                required: true,
            },
        },
        computed: {
            rejection() {
                return this.document.rejectionReason;
            },
            hasRejection() {
                return this.rejection !== null;
            },
        },
    };
</script>
